import React, { useEffect, useState } from "react";
import Navbar from "../Navbar";
import { Box, Button, TextField, Grid, Typography } from "@mui/material";
import axios from "axios";
import swal from "sweetalert";
import Divider from "@mui/material/Divider";
import { Link, useNavigate, useParams } from "react-router-dom";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import {
  createTheme,
  PaletteColorOptions,
  ThemeProvider,
} from "@mui/material/styles";
import { Stack } from "@mui/material";

function AddSubCategory() {
  const navigate = useNavigate();
  const [productInput, setProduct] = useState({
    subname: "",
    category: "",
    error_list: [],
  });
  const handleInput = (e) => {
    e.persist();
    setProduct({ ...productInput, [e.target.name]: e.target.value });
  };

  const { palette } = createTheme();
  const { augmentColor } = palette;
  const createColor = (mainColor) =>
    augmentColor({ color: { main: mainColor } });
  const theme = createTheme({
    palette: {
      anger: createColor("#F40B27"),
      apple: createColor("#A38A00"),
      steelBlue: createColor("#5C76B7"),
      violet: createColor("#BC00A3"),
    },
    button: {
      // Here is where you can customise the button
      fontSize: 16,
      fontWeight: 1700,
    },
  });

  const submitProduct = (e) => {
    e.preventDefault();
    let userId = localStorage.getItem("auth_id");
    console.log(userId);
    const data = {
      subname: productInput.subname,
      category: productInput.category,
      user_id:userId,
    };
//api calling
    axios.post(`api/add_subcategory`, data).then((res) =>{
      if(res.data.status === 200){
        swal("Success",res.data.message,"success");
        document.getElementById('SUBCATEGORY_FORM').reset();
        navigate('/certificates/subcategory');
      }
      else if(res.data.status === 400){
        setProduct({...productInput,error_list:res.data.errors});
      }
    });
  };
  //api for dropdown
  const [sublist, setsublist] = useState([]);
  useEffect(() => {
    axios.get(`api/show-product`).then((res) => {
      if (res.status === 200) {
        setsublist(res.data.product);
      }
    });
  }, []);
  const values = sublist.map((itemname) => {
    return (
      <option color="blue" value={sublist.categoryname}>
        {itemname.name}
      </option>
    );
  });
//main function
  return (
    <div>
      <Navbar />
      {/*<form onSubmit={submitProduct} id="SUBCATEGORY_FORM">*/}
      <div className="card px-8 m-5">
          {/* <Navbar/> */}
          <div className="card-header">
            <Grid container spacing={70}>
              <Grid item xs={8}>
                <h4>Add SubCategory</h4>
              </Grid>
              <Grid item xs={4}>
                {/* <Button component={Link} to="/subcategory" variant="contained" color="primary">Back</Button> */}
                <ThemeProvider theme={theme}>
                  <Button
                    component={Link}
                    to="/certificates/subcategory"
                    variant="contained"
                    color="apple"
                  >
                    Back
                  </Button>
                </ThemeProvider>
              </Grid>
            </Grid>
          </div>
          <form onSubmit={submitProduct} id="SUBCATEGORY_FORM">
           <Box padding={1} borderRadius={1} paddingLeft={35} paddingRight={35}>
             {/*<Grid container spacing={5}>*/} 
             <Grid item xs={5}>
              <Box marginTop={2} padding={1} borderRadius={1}>
                <select
                  name="category"
                  class="form-select"
                  aria-label="Default select example"
                  onChange={handleInput}
                  value={productInput.category}
                >
                  <option selected>Category</option>
                  {values}
                </select>
                <span style={{ color: "red" }}>
                  {productInput.error_list.category}
                </span>
              </Box>
             </Grid> 
            
            {/* <Grid container spacing={5}> */}
            <Grid item xs={5}>
              <TextField
                fullWidth
                name="subname"
                id="outlined-basic"
                onChange={handleInput}
                value={productInput.subname}
                margin="normal"
                label="SubCategory Name"
                variant="outlined"
              />
              <span style={{ color: "red" }}>
                {productInput.error_list.subname}
              </span>
            </Grid>
            </Box>
          <ThemeProvider theme={theme}>
            <Box
             marginTop={1}
             display="flex"
             padding={3}
             borderRadius={5}
             alignItems="center"
             justifyContent={"center"}
             >
             {/*<ThemeProvider theme={theme}>*/}
              <Button
                style={{
                  maxWidth: "200px",
                  maxHeight: "100px",
                  minWidth: "50px",
                  minHeight: "30px",
                }}
                color="apple"
                type="submit"
                variant="contained"
              >
                Add
              </Button>
            </Box>
          </ThemeProvider>
          </form>
      </div>
    </div>
  );
}

export default AddSubCategory;
